import $ from 'jquery';

import './style.scss';

let pluginApi = null;
let $issueInfo = null;
let $pageInfo = null;
let $stories = null;
let localStorage = window.localStorage;

// localStorage doesn't exist in the Android app's WebView
if ( !localStorage ) {
  localStorage = {
    getItem: () => null,
    setItem: () => undefined,
    removeItem: () => undefined,
    key: () => null,
    clear: () => undefined,
  };
}

function onReaderOpened( issue, pageIndex ) {

  // Only show the dev helper UI to admins
  if ( !pluginApi.user.isAdmin && !pluginApi.user.isEditor )
    return;

  $( document.body ).addClass( 'has-asmag-reader-dev-helper' );

  createHtmlElems( issue );
  populateIssueInfo( issue );
  populatePageInfo( pageIndex, issue.pages[ pageIndex ] );
  populateStories( issue );
}

function createHtmlElems( issue ) {

  const logActions = localStorage.getItem( 'asmag_dev_helper_log_actions' );
  const logFilters = localStorage.getItem( 'asmag_dev_helper_log_filters' );

  const $devHelper = $( `
    <div class="asmag-reader-dev-helper">
      <div class="asmag-reader-dev-helper__toolbar">
        <span data-tab="issue-info">Issue</span>
        <span data-tab="page-info">Current page</span>
        <span data-tab="stories">Stories</span>
        <span data-tab="settings">Settings</span>
      </div>
      <div class="asmag-reader-dev-helper__tabs">
        <div class="asmag-reader-dev-helper__tab" data-tab="issue-info"></div>
        <div class="asmag-reader-dev-helper__tab" data-tab="page-info"></div>
        <div class="asmag-reader-dev-helper__tab" data-tab="stories"></div>
        <div class="asmag-reader-dev-helper__tab" data-tab="settings">
          <p>
            <label><input name="log_actions" type="checkbox" ${ logActions ? 'checked="checked"' : '' }> Log actions in console</label>
            <br>
            <label><input name="log_filters" type="checkbox" ${ logFilters ? 'checked="checked"' : '' }> Log filters in console</label>
          </p>
        </div>
      </div>
    </div>
  ` );

  $devHelper.on( 'click', 'input[name="log_actions"]', event => {
    localStorage.setItem( 'asmag_dev_helper_log_actions', event.target.checked ? 'true' : '' );
  } );
  $devHelper.on( 'click', 'input[name="log_filters"]', event => {
    localStorage.setItem( 'asmag_dev_helper_log_filters', event.target.checked ? 'true' : '' );
  } );

  const hideTabs = () => {
    $( '.asmag-reader-dev-helper__tabs' ).attr( 'data-active-tab', '' );
    $( '.asmag-reader-dev-helper__tab' ).hide();
    $( '.asmag-reader-dev-helper__toolbar [data-tab]' ).removeClass( 'active' );
  };

  $devHelper.on( 'click', '.asmag-reader-dev-helper__toolbar [data-tab]', event => {
    const tabName = $( event.target ).attr( 'data-tab' );
    const isActive = $( event.target ).hasClass( 'active' );

    hideTabs();

    if ( !isActive ) {
      $( '.asmag-reader-dev-helper__tabs' ).attr( 'data-active-tab', tabName );
      $( '.asmag-reader-dev-helper__tab[data-tab="'+ tabName +'"]' ).show();
      $( '.asmag-reader-dev-helper__toolbar [data-tab="'+ tabName +'"]' ).addClass( 'active' );
    }
  } );

  $issueInfo = $devHelper.find( '.asmag-reader-dev-helper__tab[data-tab="issue-info"]' );
  $pageInfo = $devHelper.find( '.asmag-reader-dev-helper__tab[data-tab="page-info"]' );
  $stories = $devHelper.find( '.asmag-reader-dev-helper__tab[data-tab="stories"]' );

  $stories.on( 'click', '.asmag-reader-dev-helper__story-page-name', event => {
    const page = $( event.target ).closest( '.asmag-reader-dev-helper__story-page' );
    pluginApi.reader.goToPageId( page.attr( 'data-page-id' ) );
  } );

  $stories.on( 'click', '.asmag-reader-dev-helper__story-page-thumb', event => {
    const thumb = $( event.target );
    const page = thumb.closest( '.asmag-reader-dev-helper__story-page' );
    const pageId = page.attr( 'data-page-id' );
    const storyId = page.attr( 'data-story-id' );

    const callback = () => {
      $.get( pluginApi.env.site_url +'/asmag/web-app/issue/'+ issue.id ).then( issue => {
        populateStories( issue );
        $( '.asmag-reader-dev-helper__stories' ).removeClass( 'loading' );
      } );
    };

    $( '.asmag-reader-dev-helper__stories' ).addClass( 'loading' );

    if ( !storyId ) {
      $.post( pluginApi.env.site_url +'/wp-admin/admin-ajax.php', {
        action: 'asteikko_editor_createissuestory',
        issue_id: issue.id,
        first_page_id: pageId
      } ).then( callback );
    }
    else {
      $.post( pluginApi.env.site_url +'/wp-admin/admin-ajax.php', {
        action: 'asteikko_editor_deleteissuestory',
        story_id: storyId
      } ).then( callback );
    }
  } );

  $( document ).on( 'keydown.devhelper', event => {
    if ( event.keyCode === 27 ) { // Esc
      hideTabs();
    }
  } );

  $( document.body ).append( $devHelper );
}

function populateIssueInfo( issue ) {
  $issueInfo.html( `
    <table>
      <tr><td>ID</td><td>${ issue.id }</td></tr>
      <tr><td>Name</td><td>${ issue.name }</td></tr>
      <tr><td>URL slug</td><td>${ issue.slug }</td></tr>
      <tr><td>Page count</td><td>${ issue.pages.length }</td></tr>
    </table>
  ` );
}

function onPageIndexChanged( oldIndex, newIndex, oldPage, newPage ) {

  // Only show the dev helper UI to admins
  if ( !pluginApi.user.isAdmin && !pluginApi.user.isEditor )
    return;

  populatePageInfo( newIndex, newPage );
  refreshCurrentStoryPages();

  const storiesTab = $( '.asmag-reader-dev-helper__tab[data-tab="stories"]' );
  const scrollLeft = $( '.asmag-reader-dev-helper__story-page.active' ).first().position().left + storiesTab.scrollLeft() - Math.floor( $( '.asmag-reader-dev-helper__stories' ).width() / 2 ) + 150;

  storiesTab.animate( { scrollLeft: scrollLeft }, 300 );
}

function populatePageInfo( pageIndex ) {

  let html = '<div class="asmag-reader-dev-helper__current-pages">';

  pluginApi.currentSpreadPages.forEach( ( page, pageIndex ) => {
    html += `
      <div class="asmag-reader-dev-helper__current-page" data-page-id="${ page.id }">
        <table>
          <tr><td>Page</td><td>${ pluginApi.reader.issue.pages.findIndex( p => p.id === page.id ) + 1 }/${ pluginApi.reader.issue.pages.length }</td></tr>
          <tr><td>ID</td><td>${ page.id }</td></tr>
          <tr><td>Title</td><td>${ page.title }</td></tr>
          <tr><td>Excerpt</td><td>${ page.excerpt }</td></tr>
          <tr><td>URL slug</td><td>${ page.slug }</td></tr>
          <tr><td>Template</td><td>${ page.template }</td></tr>
          <tr><td>Zoomable</td><td>${ page.zoomable ? 'true' : 'false' }</td></tr>
          <tr>
            <td>Template settings</td>
            <td><pre>${ JSON.stringify( page.template_settings, null, 2 ) }</pre></td>
          </tr>
          <tr>
            <td>Thumbnail</td>
            <td>
            ${
              ( page.thumbnails )
                ? `<a href="${ page.thumbnails.thumbnail }" target="_blank"><img src="${ page.thumbnails.thumbnail }"></a>`
                : 'none'
            }
            </td>
          </tr>
          <tr>
            <td>Images on this page</td>
            <td class="asmag-reader-dev-helper__current-page-images"></td>
        </table>
      </div>
    `;
  } );

  html += '</div>';

  $pageInfo.html( html );
}

function populateStories( issue ) {

  $stories.empty();

  let previousPageStoryId = undefined;
  let html = '<div class="asmag-reader-dev-helper__stories">';

  for ( let i = 0; i < issue.pages.length; i++ ) {

    const page = issue.pages[ i ];
    const story = issue.stories.find( story => story.page_ids.includes( page.id ) );
    const storyId = ( story ) ? story.id : undefined;
    const nextPageStoryId = ( i < issue.pages.length - 1 )
      ? ( issue.stories.find( story => story.page_ids.includes( issue.pages[ i + 1 ].id ) ) || {} ).id
      : undefined;

    let cssClass = 'asmag-reader-dev-helper__story-page';

    if ( storyId ) {
      cssClass += ' asmag-reader-dev-helper__story-page--has-story';

      if ( storyId !== previousPageStoryId )
        cssClass += ' asmag-reader-dev-helper__story-page--story-start';

      if ( storyId !== nextPageStoryId )
        cssClass += ' asmag-reader-dev-helper__story-page--story-end';
    }

    let storyTitle = '';

    if ( storyId ) {
      // First page of the story
      if ( storyId !== previousPageStoryId ) {
        storyTitle = ( issue.pages.find( page => page.id == story.page_ids[ 0 ] ) || {} ).title
      }
    }

    html += `
      <div class="${ cssClass }" data-page-id="${ page.id }" data-story-id="${ ( storyId && storyId !== previousPageStoryId ) ? storyId : '' }">
        <div class="asmag-reader-dev-helper__story-page-thumb">
          ${ page.thumbnails ? `<img src="${ page.thumbnails.thumbnail }">` : `<p>Page ${ i + 1 }</p>` }

          <div class="asmag-reader-dev-helper__story-page-create">
            ${ storyId && storyId !== previousPageStoryId ? 'Delete<br>this<br>story' : 'Start<br>a&nbsp;story<br>here' }
          </div>
        </div>
        <div class="asmag-reader-dev-helper__story-page-name">
          ${ storyTitle }
        </div>
      </div>
    `;

    previousPageStoryId = storyId;
  }

  html += '</div>';

  $stories.html( html );

  refreshCurrentStoryPages();
}

function refreshCurrentStoryPages() {

  $( '.asmag-reader-dev-helper__story-page' ).removeClass( 'active' );

  pluginApi.currentSpreadPages.forEach( page => {
    $( '.asmag-reader-dev-helper__story-page[data-page-id="'+ page.id +'"]' ).addClass( 'active' );
  } );
}

function onPageShown( index, pageElem, page ) {

  // Only show the dev helper UI to admins
  if ( !pluginApi.user.isAdmin && !pluginApi.user.isEditor )
    return;

  populatePageContentInfo( pageElem, page );
}

function populatePageContentInfo( pageElem, page ) {

  const infoElem = $( '.asmag-reader-dev-helper__current-page[data-page-id="'+ page.id +'"]' );
  const imagesElem = infoElem.find( '.asmag-reader-dev-helper__current-page-images' );
  let imageUrls = [];

  $( pageElem ).find( 'img[src], *[style*="background-image:"]' ).each( ( index, elem ) => {
    elem = $( elem );

    if ( elem.is( 'img' ) ) {
      if ( /^https?:\/\//.test( elem.attr( 'src' ) ) ) {
        imageUrls.push( elem.attr( 'src' ) );
      }
    }
    else {
      const matches = ( elem.attr( 'style' ) || '' ).match( /background-image:\s*url\(([^\s()]+)\)/ );
      if ( matches && /^https?:\/\//.test( matches[ 1 ] ) ) {
        imageUrls.push( matches[ 1 ] );
      }
    }

  } );

  const liElems = imageUrls.map( url => {
    return `<li><a href="${ url }" target="_blank">${ url.replace( /^.+\//, '' ) }</a></li>`;
  } );

  imagesElem.html( `<ul>${ liElems.join( '' ) }</ul>` );
}

function onReaderClosed() {

  if ( !pluginApi.user.isAdmin && !pluginApi.user.isEditor )
    return;

  $issueInfo = null;
  $pageInfo = null;

  $( document.body ).removeClass( 'has-asmag-reader-dev-helper' );
  $( '.asmag-reader-dev-helper' ).remove();

  $( document ).off( 'keydown.devhelper' );
}

export default function registerDevHelper( _pluginApi ) {

  pluginApi = _pluginApi;

  pluginApi.addAction( 'reader_opened', 'reader_dev_helper', onReaderOpened );
  pluginApi.addAction( 'reader_closed', 'reader_dev_helper', onReaderClosed );
  pluginApi.addAction( 'reader_page_index_changed', 'reader_dev_helper', onPageIndexChanged );
  pluginApi.addAction( 'reader_page_shown', 'reader_dev_helper', onPageShown );

  // Log all actions and filters in the console. The 'all' hooks is only run
  // when the current code is compiled for non-production environments. This
  // code therefore does NOT run in production builds.

  pluginApi.addAction( 'all', 'reader_dev_helper', ( ...args ) => {

    if ( !pluginApi.user.isAdmin && !pluginApi.user.isEditor )
      return;

    const logActions = localStorage.getItem( 'asmag_dev_helper_log_actions' );

    if ( logActions ) {
      const hookName = pluginApi.currentAction();
      pluginApi.log( 'Action:', hookName, args );
    }
  } );

  pluginApi.addFilter( 'all', 'reader_dev_helper', ( ...args ) => {

    if ( !pluginApi.user.isAdmin && !pluginApi.user.isEditor )
      return args[ 0 ];

    const logFilters = localStorage.getItem( 'asmag_dev_helper_log_filters' );

    if ( logFilters ) {
      const hookName = pluginApi.currentFilter();
      pluginApi.log( 'Filter:', hookName, args );
    }

    return args[ 0 ];
  } );
}
